/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Availabletoreadforusers4Inputs */

const de__field_availabletoreadforusers4 = /** @type {(inputs: _Field_Availabletoreadforusers4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verfügbar zum Lesen für Benutzer`)
};

/**

* @param {_Field_Availabletoreadforusers4Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_availabletoreadforusers4 = /** @type {((inputs?: _Field_Availabletoreadforusers4Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Availabletoreadforusers4Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_availabletoreadforusers4(inputs)
});
export { _field_availabletoreadforusers4 as "_field_availableToReadForUsers" }